// extracted by mini-css-extract-plugin
module.exports = {"button":"style-module--button--2J-jz"};